// global shared items
require('./shared')

require('./shared_functions')

// required plugins
require('../../../../core/js/plugins/mtc_slick');
require('../../../../core/js/plugins/mtc_jquery.waypoints');
require('../../../../core/js/plugins/mtc_waypoints');

// search specific JS
require('../../../../modules/Search/js/mtc_search');

require('../site_scripts/mtc_cta_strapline');
require('../site_scripts/mtc_side_search_filter');
require('../site_scripts/mtc_slide_out_menu');
require('../site_scripts/mtc_show_hide_opening_times');
require('../site_scripts/mtc_finance_video_overlay');
require('../site_scripts/mtc_read_more_small_print');
require('../site_scripts/mtc_search_item_key_features');
require('../site_scripts/mtc_finance_tabs');
require('../site_scripts/mtc_read_more');
require('../site_scripts/mtc_item_images');
require('../search/toggle-finance-example');
require('../search/toggle-filters');
require('../search/toggle-layout');
require('../search/info-popup');
require('../search/read-more-scroll');
require('../global/accordion')

// search page specific styles
// require('../../css/search_page.less');
require('../../styles/entry/search.less');
